const { renderReady, render } = require("../../src/utils");

module.exports = class {
    onCreate(input) {
        this.state = {
            placementId: input.placementId,
            module: input.module,
            docId: `placement${input.placementId}`,
            options: input.options
        };
    }

    onMount() {
        const { module, docId } = this.state;
        const skeletonId = (this.state.options && this.state.options.skeletonId) ? this.state.options.skeletonId : undefined;
        
        if(module) {
            renderReady(module).then(() => {
                render(module, docId, document, skeletonId);
            });
        }

    }
};
